import $ from '../utils/net';
import OriginalConfig from './config';

const Config = OriginalConfig as any as {
    softionAPI: string;
    publickey: string;
};

export default class OddsPrint {
    /**
     * Recupera i tornei in base alla selezione delle categorie
     * @param categorylistBySport Mappa degli sport e delle relative categorie selezionate
     */
    static async getTournamentsFromSelection<T = any>(categorylistBySport: any): Promise<T> {
        return new Promise((resolve, reject) => {
            $.post(
                Config.softionAPI + '/stampaquote/chooseMan?json' + (!!Config.publickey ? '&public=' + Config.publickey : ''),
                { body: { manifestazione: categorylistBySport } },
                (err: any, data: any) => {
                    if (err) {
                        reject(err);
                        return;
                    }

                    let parsedData = data;
                    if (typeof data === 'string') {
                        try {
                            parsedData = JSON.parse(data);
                        } catch (e) {
                            reject(e);
                            return;
                        }
                    }

                    resolve(parsedData as T);
                }
            );
        });
    }

    /**
     * Recupera gli esiti disponibili per i tornei selezionati
     * @param tournamentlistBySportAndCategory Mappa dei tornei selezionati divisi per sport/categoria
     */
    static async getOutcomesFromTournaments<T = any>(tournamentlistBySportAndCategory: any): Promise<T> {
        return new Promise((resolve, reject) => {
            $.post(
                Config.softionAPI + '/stampaquote/chooseOdds?json' + (!!Config.publickey ? '&public=' + Config.publickey : ''),
                { body: { odds: tournamentlistBySportAndCategory } },
                (err: any, data: any) => {
                    if (err) {
                        reject(err);
                        return;
                    }

                    let parsedData = data;
                    if (typeof data === 'string') {
                        try {
                            parsedData = JSON.parse(data);
                        } catch (e) {
                            console.warn(e);
                        }
                    }

                    resolve(parsedData as T);
                }
            );
        });
    }

    /**
     * Genera il PDF delle quote
     */
    static async getPDF(
        sort: string | number,
        ori: string | number,
        logo: string | boolean,
        startdate: string,
        enddate: string,
        tournamentlistBySportAndCategory: any,
        outcomeSelection: any
    ): Promise<string> {
        return new Promise((resolve, reject) => {
            // Utilizziamo $.serialize per comporre i parametri della query string
            const qs = $.serialize({
                sort,
                ori,
                logo,
                day: 0,
                startdate,
                enddate
            });

            $.post(
                Config.softionAPI + '/stampaquote/generatePdf?json' + (!!Config.publickey ? '&public=' + Config.publickey : '') + '&' + qs,
                {
                    body: {
                        odds: tournamentlistBySportAndCategory,
                        types: outcomeSelection,
                        sequenza: JSON.stringify(outcomeSelection)
                    }
                },
                (err: any, data: any) => {
                    if (err) {
                        reject(err);
                        return;
                    }

                    // Il server restituisce il path relativo del PDF
                    resolve(Config.softionAPI + data);
                }
            );
        });
    }
}